
import React, { useState } from 'react';
import Notice from 'components/Notice';
import Banner from 'components/Banner';
import PageBox from 'components/PageBox';
import IndexPolicy from 'components/IndexPolicy';
import { Helmet } from "react-helmet";
import './index.less'
export default function App() {
  const [searchText, setSearchText] = useState('')
  return (
    <>
      <Helmet>
        <title>AiPRT官网公共资源数智采平台官网,招采平台,首页</title>
        <meta name='keywords' content='AIPRT, 公共资源数智采平台,招采平台，官网，首页' />
        <meta name='description' content='公共数智采交易平台基于用友iuap数字化底座，同时兼容SAAS服务搭建数字化智慧化的交易平台' />
      </Helmet>
      <PageBox useBanner={true}>
        <Banner onSearch={(text)=>setSearchText(text)}/>
        <Notice searchText={searchText}/>
        <IndexPolicy />
      </PageBox>
    </>
    
  );
}
